export const DOMAIN = 'askAnalyst.conversationThreads';
